import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router";

import AccountPreferenceList from "components/pages/accountPreferences/list/AccountPreferenceList";
import NotificationPreferenceList from "components/pages/notificationPreferences/list/NotificationPreferenceList";
import AlertProtocolList from "components/pages/alertProtocols/list/AlertProtocolList";

const useAccountConfiguration = () => {
  const { view } = useParams();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(view ?? "preference");

  const tabs = useMemo(() => {
    const baseTabs = [
      {
        label: "Account Preferences",
        value: "preference",
        component: <AccountPreferenceList />,
      },
      {
        label: "Alert Notification",
        value: "alert-notification",
        component: <NotificationPreferenceList />,
      },
      {
        label: "Alert Protocol",
        value: "alert-protocol",
        component: <AlertProtocolList />,
      },
    ];

    return baseTabs;
  }, []);

  const onTabChange = (newView) => {
    if (newView === currentTab) return;

    navigate(`${newView}`);
    setCurrentTab(newView);
  };

  return { tabs, currentTab, onTabChange };
};

export default useAccountConfiguration;
